import React, {  Suspense, useContext } from "react";
import { Box, Container,} from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { useMediaQuery, useTheme } from "@mui/material";
import Login from "../Login/Login";

const MainAuth = ({ onClose }) => {
    const { darkMode } = useContext(ThemeContext)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const imgSrc = darkMode ? '/hs-white.png' : '/hs-logo.png'
    const logoImg = darkMode ? "/Vfx-logo_white.png" : "/Vfx logo.png"
    return (
        <>
            <Suspense fallback={<div>Loading translations...</div>}>
                <Container maxWidth={isMobile ? false : "md"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Box sx={{ p: 4, width: 400, borderRadius: 4, textAlign: 'center', pt: 2, backgroundColor: darkMode ? '#0f1720' : 'var(--white)', boxShadow: darkMode ? 'none' : '0px 0px 40px rgba(0, 0, 0, 0.1)', }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}><img src={logoImg} alt="hs" style={{ height: 38 }} className='ms-2 my-2' /> </Box>
                            <div style={{ backgroundColor: darkMode ? '#0f1720' : 'var(--white)', overflow: "hidden", width: "100%", position: "relative", }}>
                                <Login />
                            </div>
                             <div style={{ marginTop: 10, fontSize: 12, opacity: 0.5 , color:"var(--secondaryLight2)"}}>Version {process.env.REACT_APP_VERSION}</div>
                            <div className='opacity-50' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
                                <small>Powered by </small><a href="https://hybridsolutions.com/" target='_blank'><img src={imgSrc} alt="hs" style={{ height: darkMode ? 40 : 20 }} className='ms-2' />
                                </a>
                            </div>
                        </Box>
                    </Box>
                </Container>
            </Suspense>
        </>
    );
};

export default MainAuth;
